// extracted by mini-css-extract-plugin
export default {"addByTxt":"ArticleFooter_addByTxt__81ehW","voteCount":"ArticleFooter_voteCount__9T79v","date":"ArticleFooter_date__1-PNo"};